import React from 'react'
import styled from 'styled-components'
import { Header } from './Header'
import { Preview } from './Preview'
import { Footer } from './Footer'

export const Canvas = () => (
	<StyledCanvas>
		<Header />
		<Preview />
		<Footer />
	</StyledCanvas>
)

const StyledCanvas = styled.article`
	padding: 1rem 3rem;
	grid-area: canvas;
	align-items: center;
`
